module.exports = __webpack_public_path__ + "img/sdg_es_(2).94d5e505.png";